














import CtrlButton from "@/app/core/component/CtrlButton.vue";
import WindowVue from "@/app/core/window/WindowVue";
import { Component, Mixins } from "vue-mixin-decorator";
import { ServerTestResult } from "@/@types/socket";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { TargetVersion } from "@/app/core/api/Github";
import VueEvent from "@/app/core/decorator/VueEvent";
import VersionInfoComponent from "@/app/basic/login/VersionInfoComponent.vue";

@Component({
  components: {
    VersionInfoComponent,
    CtrlButton
  }
})
export default class VersionInfoWindow extends Mixins<
  WindowVue<ServerTestResult, void>
>(WindowVue) {
  private serverTestResult: ServerTestResult | null = null;

  @LifeCycle
  public async mounted() {
    await this.init();
    this.serverTestResult = this.windowInfo.args!;
  }

  @VueEvent
  private async commit() {
    await this.close();
  }
}
